import { useEffect, useRef } from 'react';
import { usePixelConfig } from '@/hooks/usePixelConfig';
import { initializeGA4 } from '@/lib/googleAnalytics';

export function GoogleAnalytics() {
  const isInitialized = useRef(false);
  const config = usePixelConfig();

  // Initialize GA4 when config is available
  useEffect(() => {
    if (isInitialized.current || !config.ga4MeasurementId) return;

    const measurementId = config.ga4MeasurementId;

    // Load gtag.js script dynamically if not already loaded
    // (may already be loaded by index.html pre-init from cached config)
    if (!document.querySelector(`script[src*="googletagmanager.com/gtag/js"]`)) {
      const script = document.createElement('script');
      script.async = true;
      script.src = `https://www.googletagmanager.com/gtag/js?id=${measurementId}`;
      document.head.appendChild(script);

      window.dataLayer = window.dataLayer || [];
      window.gtag = function gtag() {
        // eslint-disable-next-line prefer-rest-params
        window.dataLayer.push(arguments);
      };
      window.gtag('js', new Date());
    }

    // If pre-initialized by index.html cache, skip redundant config call
    if (!window.__GA4_PRE_INITIALIZED__) {
      initializeGA4(measurementId);
    } else {
      console.log('GA4 already pre-initialized from cache, skipping redundant config');
    }

    isInitialized.current = true;

    // NOTE: PageView tracking is handled by FacebookPixel.tsx which generates
    // a shared event_id for both FB and GA4 to ensure proper dashboard dedup.
    console.log('GA4 initialized:', measurementId);
  }, [config.ga4MeasurementId]);

  return null;
}
